import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher';

const Dashboard = () => <div className="p-6">Dashboard Content</div>;

const App = () => {
  const { t } = useTranslation();

  return (
    <Router>
      <div className="flex h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 flex flex-col">
          <div className="p-4 bg-white shadow-md flex justify-end">
            <LanguageSwitcher />
          </div>
          <main className="flex-1 p-6 overflow-auto">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/teams" element={<div>{t('teams')}</div>} />
              <Route path="/add-edit-team" element={<div>{t('addEditTeam')}</div>} />
              <Route path="/team-members" element={<div>{t('teamMembers')}</div>} />
              <Route path="/add-edit-member" element={<div>{t('addEditMember')}</div>} />
              <Route path="/user-page" element={<div>{t('userPage')}</div>} />
              <Route path="/projects" element={<div>{t('projects')}</div>} />
              <Route path="/add-edit-project" element={<div>{t('addEditProject')}</div>} />
              <Route path="/project-details" element={<div>{t('projectDetails')}</div>} />
              <Route path="/sub-project-details" element={<div>{t('subProjectDetails')}</div>} />
              <Route path="/add-edit-sub-project" element={<div>{t('addEditSubProject')}</div>} />
              <Route path="/add-edit-task" element={<div>{t('addEditTask')}</div>} />
              <Route path="/task-details" element={<div>{t('taskDetails')}</div>} />
              <Route path="/notifications" element={<div>{t('notifications')}</div>} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
};

export default App;